import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
} from '@mui/material';

export function SimpleTable({ sx, rows, size, header = true, ...passThrough }) {
  return (
    <TableContainer sx={sx} {...passThrough}>
      <Table size={size}>
        {header ? (
          <TableHead>
            <TableRow>
              {Object.keys(rows[0]).map((headerCell, rowIndex) => (
                <TableCell key={rowIndex}>{headerCell}</TableCell>
              ))}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {Object.values(row).map((cell, cellIndex) => (
                <TableCell key={cellIndex}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
